module.exports = __webpack_public_path__ + "img/qr_code.c822d208.png";